// src/components/ui/Card.jsx
import React from "react";
import { cn } from "../../utils/cn";

const CardRoot = ({ as: Component = "div", className, ...props }) => (
  <Component className={cn("afrimed-card", className)} {...props} />
);

const CardHeader = ({ className, ...props }) => (
  <div className={cn("afrimed-card-header", className)} {...props} />
);

const CardTitle = ({ className, ...props }) => (
  <h3 className={cn("afrimed-card-title", className)} {...props} />
);

const CardDescription = ({ className, ...props }) => (
  <p className={cn("afrimed-card-description", className)} {...props} />
);

const CardContent = ({ className, ...props }) => (
  <div className={cn("afrimed-card-content", className)} {...props} />
);

const CardFooter = ({ className, ...props }) => (
  <div className={cn("afrimed-card-footer", className)} {...props} />
);

// Default export = root
const Card = CardRoot;
export default Card;

// Named shims (so existing imports keep working)
export { CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
